// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "content-1pZma";
var _3 = "banner_meal-1muFL";
var _4 = "banner_seat-ZfzLW";
var _5 = "banner_baggage-1dONw";
var _6 = "image-1QRxB";
export { _1 as "__esModule", _2 as "content", _3 as "banner_meal", _4 as "banner_seat", _5 as "banner_baggage", _6 as "image" }
export default { "__esModule": _1, "content": _2, "banner_meal": _3, "banner_seat": _4, "banner_baggage": _5, "image": _6 }
